import React from 'react'
import { useParams } from 'react-router-dom'
import LoanHeader from './loan/LoanHeader'
import Page, { PageProps } from './Page'
import { useLoanContext } from '../contexts/LoanContext'

const LoanPage = ({ children, ...rest }: PageProps) => {
	const { setActiveLoanId } = useLoanContext()
	const { loanId: loanIdParam } = useParams()

	React.useEffect(() => {
		if (loanIdParam) {
			setActiveLoanId(loanIdParam)
		}
	}, [loanIdParam, setActiveLoanId])
	return (
		<Page {...rest}>
			<LoanHeader />
			<div className="px-5 overflow-auto">
				<main>{children}</main>
			</div>
		</Page>
	)
}

export default LoanPage
